export default __webpack_public_path__ + "static/media/user.ff10bb2e.svg";